import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { UnitProfileDto } from '@hisense/shared';
export const unitProfilesPage=(q:string,page:number,archived:boolean,signal?:AbortSignal)=>apiFetch<{data:UnitProfileDto[];hasMore:boolean;total:number}>('/unit-pricing',{query:{q,page,archived:String(archived)},signal});
export const useUnitProfiles=(q:string,page:number,archived:boolean)=>useQuery({queryKey:['unit-profiles',q,page,archived],queryFn:({signal})=>unitProfilesPage(q,page,archived,signal)});
export const unitProfilePage=(id?:string,signal?:AbortSignal)=>apiFetch<{data:UnitProfileDto}>(`/unit-pricing/${id}`,{signal});
export const useUnitProfile=(id?:string)=>useQuery({queryKey:['unit-profile',id],queryFn:({signal})=>unitProfilePage(id,signal),enabled:!!id});
export const commercialUnitOptions=(productId:string,signal?:AbortSignal)=>apiFetch<{data:import('@hisense/shared').CommercialUnitOptions}>(`/unit-pricing/products/${productId}/options`,{signal});
/** Hiện trạng quy đổi của MỘT sản phẩm, để bảng trong màn hình Sản phẩm đọc. */
export const useCommercialUnitOptions=(productId?:string)=>useQuery({queryKey:['unit-options',productId],queryFn:({signal})=>commercialUnitOptions(productId!,signal),enabled:!!productId});
/**
 * Trong các mã của một chứng từ, mã nào đang có hồ sơ quy đổi ĐÃ DUYỆT (19/09/2026). Bảng dòng hàng chỉ hiện nút "Đơn vị & giá"
 * cho các mã này: mã chưa có hồ sơ thì hộp chọn chỉ có đơn vị gốc, nút chỉ làm rối dòng. Không có quyền xem Đơn vị & bảng giá
 * (API trả 403) hay lỗi mạng thì coi như không mã nào — nút ẩn, không hiện lỗi giữa bảng.
 */
export function useActiveUnitProducts(productIds: readonly string[]): ReadonlySet<string> {
  const ids = [...new Set(productIds.filter(Boolean))].sort();
  const query = useQuery({
    queryKey: ['unit-profiles', 'active-products', ids],
    queryFn: ({ signal }) => apiFetch<{ data: string[] }>('/unit-pricing/active-products', { query: { productIds: ids.join(',') }, signal }),
    enabled: ids.length > 0,
    retry: false,
    staleTime: 60_000,
  });
  return new Set(query.data?.data ?? []);
}
